import {FETCH_FULL_PRODUCTS, CLEAN_FULL_PRODUCTS, DELETE_FULL_PRODUCT, DELETE_FULL_PRODUCTS} from '../actions/types';

const FULL_PRODUCTS_DEFAULT_STATE = {};

const FullProductsReducer = (state = FULL_PRODUCTS_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_FULL_PRODUCTS:
            return payload;

        case CLEAN_FULL_PRODUCTS:
        case DELETE_FULL_PRODUCT:
        case DELETE_FULL_PRODUCTS:
            return FULL_PRODUCTS_DEFAULT_STATE;

        default:
            return state;
    }
};

export default FullProductsReducer;
